"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _UrlPicker = _interopRequireDefault(require("./UrlPicker"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _PasscodePrompt = _interopRequireDefault(require("./PasscodePrompt"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UrlConfig = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function UrlConfig() {
    _classCallCheck(this, UrlConfig);
    return _callSuper(this, UrlConfig, arguments);
  }
  _inherits(UrlConfig, _React$Component);
  return _createClass(UrlConfig, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$fields = this.props.fields,
        respondentConfig = _this$props$fields.respondentConfig,
        requireLogin = _this$props$fields.requireLogin;
      if (respondentConfig.value !== 'managed' && requireLogin.value === true) {
        requireLogin.onChange(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$fields2 = this.props.fields,
        individualPasscode = _this$props$fields2.individualPasscode,
        passcodeBackground = _this$props$fields2.passcodeBackground,
        passcodeBackgroundColor = _this$props$fields2.passcodeBackgroundColor,
        passcodeCompletionButtonText = _this$props$fields2.passcodeCompletionButtonText,
        passcodeLabel = _this$props$fields2.passcodeLabel,
        requireLogin = _this$props$fields2.requireLogin,
        respondentConfig = _this$props$fields2.respondentConfig;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: requireLogin,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "How will respondents access the Quest?",
          tooltip: "You can modify the link by checking the box for 'Use custom URL'. For certain user types you can also choose to provide one link all respondents access or generate unique links for each respondent."
        })
      }, respondentConfig.value === 'managed' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-check-input",
        type: "radio",
        onChange: function onChange() {
          return requireLogin.onChange(false);
        },
        checked: !requireLogin.value,
        value: "personal"
      }), ' ', "Each respondent will receive a personal URL (no login)")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-check-input",
        type: "radio",
        onChange: function onChange() {
          return requireLogin.onChange(true);
        },
        checked: requireLogin.value,
        value: "login"
      }), ' ', "Respondents will login via a single URL")))), respondentConfig.value === 'manual' && /*#__PURE__*/_react["default"].createElement("div", {
        className: "mt-n3"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: individualPasscode
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-check-input",
        type: "radio",
        checked: !individualPasscode.value,
        onChange: function onChange() {
          individualPasscode.onChange(false);
        },
        value: !individualPasscode.value
      }), ' ', "Respondents will receive a personal URL (no passcode)")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-check-input",
        type: "radio",
        checked: individualPasscode.value,
        onChange: function onChange() {
          individualPasscode.onChange(true);

          // initialize these settings for older Deployments that
          // were created before these settings existed
          if (!passcodeBackground.value) {
            passcodeBackground.onChange('solidColor');
          }
          if (!passcodeBackgroundColor.value) {
            passcodeBackgroundColor.onChange('#F1F0F5');
          }
          if (!passcodeCompletionButtonText.value) {
            passcodeCompletionButtonText.onChange('Ok');
          }
          if (!passcodeLabel.value) {
            passcodeLabel.onChange('Your Passcode');
          }
        },
        value: individualPasscode.value
      }), ' ', "Respondents will enter a passcode at a single URL"))), individualPasscode.value === true && /*#__PURE__*/_react["default"].createElement(_PasscodePrompt["default"], {
        fields: this.props.fields
      })), (respondentConfig.value === 'anonymous' || respondentConfig.value === 'manual' && !!individualPasscode.value || respondentConfig.value === 'managed' && !!requireLogin.value) && /*#__PURE__*/_react["default"].createElement("div", {
        style: respondentConfig.value === 'manual' ? {
          marginLeft: '2em'
        } : {}
      }, /*#__PURE__*/_react["default"].createElement(_UrlPicker["default"], {
        fields: this.props.fields
      })), respondentConfig.value === 'previous' && /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          position: 'relative',
          top: '-10px'
        }
      }, /*#__PURE__*/_react["default"].createElement("i", null, "You will be able to edit this later after saving this Data Collection Wave.")));
    }
  }]);
}(_react["default"].Component);
_defineProperty(UrlConfig, "propTypes", {
  fields: _propTypes["default"].object
});